/* eslint-disable */

<template>
  <div>
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row" :class="{ 'cursor-drag': draggingCard === true }">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="wordBank">
              <h5 v-for="(block, index) in dragBlocks" :key="block + index" class="dragBlock font-semibold cursor-pointer">{{ block }}</h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="grid grid-cols-3 w-full">
              <div class="flex flex-col gap-3 p-6 main-right-border">
                <div class="flex items-center justify-center p-2 rounded-lg bg-lightest font-medium">OWASP Top 10</div>

                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input0">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input1">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input2">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input3">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input4">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input5">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input6">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input7">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input8">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input9">
                </vue-draggable-container>
              </div>

              <div class="flex flex-col gap-3 p-6 main-right-border">
                <div class="flex items-center justify-center p-2 rounded-lg bg-lightest font-medium">OWASP Top 10 LLMs</div>

                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input10">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input11">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input12">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input13">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input14">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input15">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input16">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input17">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input18">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input19">
                </vue-draggable-container>
              </div>

              <div class="flex flex-col gap-3 p-6">
                <div class="flex items-center justify-center p-2 rounded-lg bg-lightest font-medium">STRIDE</div>

                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input20">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input21">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input22">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input23">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input24">
                </vue-draggable-container>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input25">
                </vue-draggable-container>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';
import shuffle from 'shuffle-array';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      dragBlocks: [
        'Overreliance',
        'Insecure plugin design',
        'Authentication Failures',
        'Broken Access Control',
        'Model denial of service',
        'Security Logging & Alerting Failures',
        'Information Disclosure',
        'Security Misconfiguration',
        'Insecure output handling',
        'Injection',
        'Prompt injection',
        'Repudiation',
        'Supply chain vulnerabilities',
        'Tampering',
        'Software or Data Integrity Failures',
        'Elevation of Privilege',
        'Excessive agency',
        'Sensitive information disclosure',
        'Insecure Design',
        'Software Supply Chain Failures',
        'Spoofing',
        'Mishandling of Exceptional Conditions',
        'Denial of Service',
        'Model theft',
        'Training data poisoning',
        'Cryptographic Failures',
      ],

      answers: {
        owasp: [
          'Broken Access Control',
          'Security Misconfiguration',
          'Software Supply Chain Failures',
          'Cryptographic Failures',
          'Injection',
          'Insecure Design',
          'Authentication Failures',
          'Software or Data Integrity Failures',
          'Security Logging & Alerting Failures',
          'Mishandling of Exceptional Conditions',
        ],
        llm: [
          'Prompt injection',
          'Insecure output handling',
          'Training data poisoning',
          'Model denial of service',
          'Supply chain vulnerabilities',
          'Sensitive information disclosure',
          'Insecure plugin design',
          'Excessive agency',
          'Overreliance',
          'Model theft',
        ],
        stride: ['Spoofing', 'Tampering', 'Repudiation', 'Information Disclosure', 'Denial of Service', 'Elevation of Privilege'],
      },

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel();
        }
      }
    },
    markSimulation() {
      let totalScore = 0;

      const sections = [
        { ids: Array.from({ length: 10 }, (_, i) => `input${i}`), valid: this.answers.owasp },
        { ids: Array.from({ length: 10 }, (_, i) => `input${i + 10}`), valid: this.answers.llm },
        { ids: Array.from({ length: 6 }, (_, i) => `input${i + 20}`), valid: this.answers.stride },
      ];

      sections.forEach((section) => {
        const usedAnswers = new Set();

        section.ids.forEach((id) => {
          const el = document.getElementById(id);
          if (!el) return;

          const value = el.textContent.trim();

          // reset style
          el.style.border = '1px solid transparent';

          if (!value) return;

          const isValid = section.valid.includes(value);
          const isDuplicate = usedAnswers.has(value);

          if (isValid && !isDuplicate) {
            el.style.border = '1px solid #28C76F';
            usedAnswers.add(value);
            totalScore++;
          } else {
            el.style.border = '1px solid #EA5455';
          }
        });
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  created() {
    this.dragBlocks = shuffle(this.dragBlocks);
  },
  components: {
    draggable,
    shuffle,
    Prism,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
#wordBank {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 0.6rem;
}
.vx-card__body {
  height: 100%;
  padding: 0rem !important;
}
</style>
